import { Button } from "../../components/ui/button";
// import heroPanther from "../../assets/hero-panther.webp";
import desktopWallpaper from "../../assets/images/Destop-wallpaper.webp";
import flowerHead1 from "../../assets/images/Flower-Head-1.webp";
import flowerHead2 from "../../assets/images/Flower-Head-2.webp";
import lockWallpaper from "../../assets/images/Lock-wallpaper.webp";
import websitePage from "../../assets/images/Website-Page.webp";
import "./style.css";
import React, { useState, useEffect } from "react";

const images = [desktopWallpaper, flowerHead1, flowerHead2, lockWallpaper, websitePage];
const SLIDE_INTERVAL = 10000; // 5 seconds

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // auto-change background images every x seconds
  useEffect(() => {
    // set up for interval to change slideshow image
    const intervalid = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length); // loop back to zero when at the end
    }, SLIDE_INTERVAL);

    // clean up interval on component unmount
    return () => clearInterval(intervalid)
  });

  return (
    <section className="hero-section">
      {/* Background Image */}
      {/* <div className="hero-bg">
        <img
          src={heroPanther}
          alt="Dramatic panther with golden eyes"
          className="hero-img"
        />
        <div className="hero-overlay" />
      </div> */}

      {/* Slideshow Background */}
      <div className="hero-bg-slideshow">
        {images.map((image, index) => (
          <div
            key={index}
            className={`slide ${index === currentImageIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image})` }}
          >
            {/* <div>WORK!!!!!!!!!!!!</div> */}
          </div>
        ))}
      </div>

      {/* Content */}
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            WELCOME TO<br />
            BIG CAT GRAPHICS
          </h1>
          
          <p className="hero-subtitle">
            We specialize in 3D design, CGI, and graphic design to bring your creative ideas to life with cutting-edge visuals and exceptional quality.
          </p>

          <div className="hero-buttons">
            <Button 
              size="lg" 
              className="hero-buttons"
              style={{ color: '#fbbf24', borderColor: '#fbbf24', backgroundColor: 'black' }}
            >
              <a href="#contact">CONTACT US</a>
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="hero-buttons"
              style={{ color: '#fbbf24', borderColor: '#fbbf24' }}
            >
              <a href="#portfolio">VIEW PORTFOLIO</a>
            </Button>
          </div>
        </div>

        {/* Experience Badge */}
        <br />
        <div className="hero-badge">
          <div className="badge-text">
            <div className="badge-number">10</div>
            <div className="badge-label">Years</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <div className="scroll-track">
          <div className="scroll-dot"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;